"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React from "react"
import useNavigationRequests from "../../../../../hooks/useNavigationRequests"
import AppBarContainer from "../AppBarContainer"
import ClientSideMenuButtons from "../ClientSideMenuButtons"
import ZestLifeLogo from "../ZestLifeLogo"
import NavBarSkeleton from "../NavBarSkeleton"
import useGetMe from "../../../../../hooks/useGetMe"
import type { TopNavBarProps } from "../types"

// Client-side navigation bar - shows skeleton until data loads
function ClientNavBar({
  startingBackgroundSolid,
  isLeaderLandingPage,
  isNoFindAGroupButton,
  mobileSignUpButton,
  mobileLoginButton,
  hideProviderOnboardingBanner,
}: TopNavBarProps) {
  const { enabled } = useNavigationRequests()
  const [{ loading, userId, authRole, me, orgId }] = useGetMe({ enabled })

  // Session status comes from context (hydrated by the server layout), so it is
  // known on the first render — both on the server and the client — which keeps
  // SSR/CSR consistent and avoids a hydration mismatch.
  //
  // Logged-out visitors (the home page's main audience) render the real nav
  // immediately with no skeleton and no data fetch. Only show the skeleton while
  // an authenticated session is still loading its profile from /edge/get-me.
  const isLoggedOut = !enabled

  if (!isLoggedOut && loading) {
    return (
      <NavBarSkeleton
        startingBackgroundSolid={startingBackgroundSolid}
        hideProviderOnboardingBanner={hideProviderOnboardingBanner}
      />
    )
  }

  return (
    <AppBarContainer
      startingBackgroundSolid={startingBackgroundSolid}
      hideProviderOnboardingBanner={hideProviderOnboardingBanner}
    >
      <ZestLifeLogo />
      <ClientSideMenuButtons
        startingBackgroundSolid={startingBackgroundSolid}
        isLeaderLandingPage={isLeaderLandingPage}
        isNoFindAGroupButton={isNoFindAGroupButton}
        mobileSignUpButton={mobileSignUpButton}
        mobileLoginButton={mobileLoginButton}
        userId={userId}
        authRole={authRole}
        me={me}
        orgId={orgId}
      />
    </AppBarContainer>
  )
}

export default ClientNavBar
